import React, { useContext } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate, useLocation } from "react-router";
import classes from "./EndListScreen.module.scss";
import * as r from "../../../../constants/routes";

import PageHeader from "../../../../components/Headers/PageHeader";
import { prettySubPathUrl, simplestText } from "../../../../helpers";
import UserTrainingContext from "../../../../context/userTrainingContext";
import PageMain from "../../../../components/Main/PageMain";
import Spinner from "../../../../components/Spinner";
import RoundButton from "../../../../components/Buttons/RoundButton";
import ButtonsArea from "../../../../components/Buttons/ButtonsArea";


export default function EndListScreen() {
    const tContext = useContext(UserTrainingContext);
    const { t } = useTranslation();
    const history = useNavigate();

    const { game_list, active_category, setGameUrl } = tContext ?? {};
    let urlCategory = ''
    if (urlCategory === "memoria") urlCategory = "Memória";
    if (urlCategory === "escuta-ativa") urlCategory = "Escuta Ativa";
    if (urlCategory === "agilidade-mental") urlCategory = "Agilidade Mental";
    if (urlCategory === "foco") urlCategory = "Foco";
    const mapBtn: { [v: string]: any } = {};

    game_list?.forEach((game: any) => {
        if (game.abilities) {
            if (game.abilities[0]) mapBtn[game.abilities[0]] = game.abilities[0];
            if (game.abilities[1]) mapBtn[game.abilities[1]] = game.abilities[1];
        }
    });
    let _content = null
    _content = <Spinner center />;
    _content = Object.keys(mapBtn).map((category: string) => {
        return (
            <RoundButton
                small
                key={category}
                text={category}
                title={category}
                onClick={() => {
                    history(r.GET_R_U_TRAIN_CAT_SMART(prettySubPathUrl(category)));
                }}
            />
        );
    });
    _content = <ButtonsArea vert>{_content}</ButtonsArea>;
    const activeCategoryAux = urlCategory;

    let title = "";
    let subtitle = "";
    switch (simplestText(activeCategoryAux)) {
        case simplestText("Escuta Ativa"):
            title = "global.title_escuta_ativa";
            subtitle = "global.subtitle_escuta_ativa";
            break;
        case simplestText("Memória"):
            title = "global.title_memoria";
            subtitle = "global.subtitle_memoria";
            break;
        case simplestText("Foco"):
            title = "global.title_foco";
            subtitle = "global.subtitle_foco";
            break;
        case simplestText("Agilidade Mental"):
            title = "global.title_agilidade_mental";
            subtitle = "global.subtitle_agilidade_mental";
            break;
        default:
            title = "global.training";
            break;
    }


    return (
        <section>{_content}</section>
    );
}